/**
 * Default entity ATIs for Confluence (1P).
 *
 * Intentionally excludes:
 * - `calendar` / `space-calendar` — handled via team-calendars plugin ATIs separately
 * - Legacy plugin ATIs (confluence.com.atlassian.confluence.extra.team-calendars:*, confluence.ac:*) — handled separately
 */
import type { ConfluenceEntityATI } from '@atlassian/search-client/common/types';

export type ReadonlyConfluenceEntityATI = readonly ConfluenceEntityATI[];

export const DEFAULT_CONFLUENCE_ENTITY_ATI: ReadonlyConfluenceEntityATI = [
	'ati:cloud:confluence:page',
	'ati:cloud:confluence:blogpost',
	'ati:cloud:confluence:attachment',
	'ati:cloud:confluence:space',
	'ati:cloud:confluence:whiteboard',
	'ati:cloud:confluence:database',
	'ati:cloud:confluence:embed',
	'ati:cloud:confluence:folder',
	'ati:cloud:confluence:slide',
	'ati:cloud:confluence:comment',
	'ati:cloud:confluence:answer',
	'ati:cloud:confluence:question',
];
